<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Marketplaces credentials') }}</Tab>
                <Tab value="2">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="seller_name"
                                       label="Seller name"
                                       size="4"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.seller_name" />

                        <FormInputText fieldName="code"
                                       label="Code"
                                       size="4"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.code" />


                        <FormInputText fieldName="email"
                                       label="Email"
                                       size="4"
                                       :validation="['required']"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.email" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="address"
                                       label="Address"
                                       size="4"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.address" />

                        <FormInputText fieldName="phone"
                                       label="Phone"
                                       size="4"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.phone" />

                        <FormInputToggleButton fieldName="is_active"
                                               label="Is active seller?"
                                               size="4"
                                               :isFormDisabled="isFormDisabled"
                                               v-model:field="crud.is_active" />

                    </div>
                </TabPanel>
                <TabPanel value="1"
                          headerClass="form-tab-header">
                    <FormRepeaterTable v-model:record="crud.credentials"
                                       :keys="{ 'marketplace_id': null, 'environment': null, 'client_id': null, 'client_secret': null, 'ru_name': null, 'refresh_token': null, 'access_token': null, 'marketplace_account_id': null, 'shop_id': null, 'region': null, 'additional_config': null, 'scopes': null, 'description': null, 'is_active': true }"
                                       :disabled="isFormDisabled"
                                       :isFirstRowEmpty="false"
                                       style="font-size:13px;"
                                       :isCopyButton="true"
                                       repeaterStyle="margin-top:5px;width:100%"
                                       name="credentials"
                                       :title="['', __('Marketplace'), __('Environment'), __('Client ID'), __('Client Secret'), __('Ru Name'), __('Refresh Token'), __('Access Token'), __('Marketplace Account ID'), __('Shop ID'), __('Region'), __('Additional Config'), __('OAuth scopes'), __('Description'), __('Is active?'), '']">
                        <template #repeat="slotProps">
                            <td :style="slotProps.cellStyle">
                                <Button v-if="props.formProps.editMode == false && props.formProps.addMode == false"
                                        name="renewToken"
                                        :style="{ width: '150px' }"
                                        @click="() => renewToken(slotProps.record)"
                                        severity="info">
                                    {{ __('Renew token') }}
                                </Button>
                            </td>

                            <td :style="slotProps.cellStyle">
                                <FormSelect :style="{ width: '200px' }"
                                            fieldName="marketplace_id"
                                            showClear
                                            validation="required"
                                            :inRepeater="true"
                                            :isFormDisabled="isFormDisabled"
                                            :options="select?.marketplaces"
                                            :filtering="false"
                                            v-model:field="slotProps.record.marketplace_id" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormSelect :style="{ width: '200px' }"
                                            showClear
                                            fieldName="environment"
                                            validation="required"
                                            :isFormDisabled="isFormDisabled"
                                            :inRepeater="true"
                                            :options="select?.environments"
                                            :filtering="false"
                                            v-model:field="slotProps.record.environment" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormInputText :style="{ width: '350px' }"
                                               fieldName="client_id"
                                               validation="required"
                                               :isFormDisabled="isFormDisabled"
                                               :inRepeater="true"
                                               v-model:field="slotProps.record.client_id" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormInputText :style="{ width: '350px' }"
                                               fieldName="client_secret"
                                               :isFormDisabled="isFormDisabled"
                                               :inRepeater="true"
                                               v-model:field="slotProps.record.client_secret" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormInputText :style="{ width: '250px' }"
                                               fieldName="ru_name"
                                               :isFormDisabled="isFormDisabled"
                                               :inRepeater="true"
                                               v-model:field="slotProps.record.ru_name" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormTextarea :style="{ width: '350px' }"
                                              :inputStyle="{ fontSize: '11px' }"
                                              fieldName="refresh_token"
                                              rows="3"
                                              cols="30"
                                              :isFormDisabled="isFormDisabled"
                                              :inRepeater="true"
                                              v-model:field="slotProps.record.refresh_token" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormTextarea :style="{ width: '350px' }"
                                              :inputStyle="{ fontSize: '11px' }"
                                              fieldName="access_token"
                                              rows="3"
                                              cols="30"
                                              :isFormDisabled="isFormDisabled"
                                              :inRepeater="true"
                                              v-model:field="slotProps.record.access_token" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormInputText :style="{ width: '150px' }"
                                               fieldName="marketplace_account_id"
                                               :isFormDisabled="isFormDisabled"
                                               :inRepeater="true"
                                               v-model:field="slotProps.record.marketplace_account_id" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormInputText :style="{ width: '150px' }"
                                               fieldName="shop_id"
                                               :isFormDisabled="isFormDisabled"
                                               :inRepeater="true"
                                               v-model:field="slotProps.record.shop_id" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormInputText :style="{ width: '150px' }"
                                               fieldName="region"
                                               :isFormDisabled="isFormDisabled"
                                               :inRepeater="true"
                                               v-model:field="slotProps.record.region" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormInputText :style="{ width: '350px' }"
                                               fieldName="additional_config"
                                               :isFormDisabled="isFormDisabled"
                                               :inRepeater="true"
                                               v-model:field="slotProps.record.additional_config" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormTextarea :style="{ width: '450px' }"
                                              :inputStyle="{ fontSize: '11px' }"
                                              fieldName="scopes"
                                              rows="3"
                                              cols="30"
                                              :isFormDisabled="isFormDisabled"
                                              :inRepeater="true"
                                              v-model:field="slotProps.record.scopes" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormTextarea :style="{ width: '350px' }"
                                              fieldName="description"
                                              rows="3"
                                              cols="30"
                                              :isFormDisabled="isFormDisabled"
                                              :inRepeater="true"
                                              v-model:field="slotProps.record.description" />
                            </td>
                            <td :style="slotProps.cellStyle">
                                <FormCheckbox fieldName="is_active"
                                              :isFormDisabled="isFormDisabled"
                                              :inRepeater="true"
                                              v-model:field="slotProps.record.is_active" />
                            </td>

                            <td :style="slotProps.cellStyle">
                                <Button v-if="props.formProps.editMode == false && props.formProps.addMode == false"
                                        name="renewToken"
                                        :style="{ width: '150px' }"
                                        @click="() => renewToken(slotProps.record)"
                                        severity="info">
                                    {{ __('Renew token') }}
                                </Button>
                            </td>
                        </template>
                    </FormRepeaterTable>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="2"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted, onBeforeMount } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from "@pages/Helper/crud_utils.js";
import FormInputText from "@crud/FormInputText.vue";
import FormButtons from "@crud/FormButtons.vue";
import FormInputToggleButton from "@crud/FormInputToggleButton.vue";
import ChangeLog from "@crud/ChangeLog.vue";
import FormRepeaterTable from "@crud/FormRepeaterTable.vue";
import FormSelect from "@crud/FormSelect.vue";
import FormCheckbox from "@crud/FormCheckbox.vue";
import FormTextarea from "@crud/FormTextarea.vue";
import Button from "primevue/button";
import { __, screenMessage, getRecord } from "@pages/Helper/utils.js";
import { onFilterService } from "@pages/Helper/crud_utils.js";

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
});

const isLoading = ref(true);
const isFormDisabled = ref(false);

const options = ["marketplaces", "environments"];
const select = ref(null);
const crud = ref({});
const buttonsVisibility = ref({});

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select, buttonsVisibility);
});

// -----------------------------------------------------

const onFilter = async (event, option) => {
    await onFilterService(event, option, select, isLoading);
}

// -----------------------------------------------------

const renewToken = async (credential) => {
    if (!credential.client_id || !credential.client_secret || !props.formProps.data.id) {
        screenMessage({ message: __('No authorisation data of client or Seller ID'), title: __('Error'), type: 'error', position: 'center', timeout: 10 });
        return;
    }

    let marketplaceCode = '';
    if (Array.isArray(select.value.marketplaces)) {
        marketplaceCode = select.value.marketplaces.find(m => m.value === credential.marketplace_id)?.label || 0;
    }

    switch (marketplaceCode) {
        case 'eBay DE':
            await renewEbayToken(credential);
            break;
        case 'Allegro':
            await renewAllegroToken(credential);
            break;

        default:
            screenMessage({ message: __('Refresh tokens is not supported for this marketplace'), title: __('Info'), type: 'info', position: 'center', timeout: 10 });
    }

    props.formProps.closeModal();
}

// -------------------------------------------------------------------------------------------------

// Funkcja nasłuchująca wiadomości po odnowieniu tokena wysłanej ze skryptu \resources\views\oauth\callback.blade.php
const handleMessageListener = (event) => {
    // Opcjonalnie: Sprawdź, czy wiadomość pochodzi z zaufanego źródła
    // if (event.origin !== 'oczekiwane-zrodlo') return;

    // Sprawdź, czy dane mają oczekiwaną strukturę
    if (event.data && (event.data.status === 'success' || event.data.status === 'error')) {
        const message = {
            message: event.data.message,
            title: event.data.status === 'success' ? __('Success') : __('Error'),
            type: event.data.status,
            position: "center",
            timeout: 10
        };
        screenMessage(message);

        // WAŻNE: Usuń listener po otrzymaniu wiadomości, aby zakończyć nasłuchiwanie.
        window.removeEventListener('message', handleMessageListener);
    }
};

// -------------------------------------------------------------------------------------------------
// Funkcja do odnowienia refresh tokena eBay
const renewEbayToken = async (credential) => {
    const arrScopes = (credential.scopes || '')
        .split(/[\n\s,;]+/)
        .map(s => s.trim())
        .filter(s => s.length > 0);

    const conf = await getRecord('marketplaces', ['base_url_prod', 'base_url_sandbox', 'auth_url_prod', 'auth_url_sandbox'], { 'id': credential.marketplace_id });

    if (!conf) {
        screenMessage({ message: __('No marketplace configuration found'), title: __('Error'), type: 'error', position: 'center', timeout: 10 });
        return;
    }

    const isProduction = (credential.environment === 'production');
    const baseMainUrl = isProduction ? conf.base_url_prod : conf.base_url_sandbox;
    const authMainUrl = isProduction ? conf.auth_url_prod : conf.auth_url_sandbox;

    // Pobierz parametry potrzebne do zbudowania URL autoryzacji
    const clientId = credential.client_id;
    const ruName = credential.ru_name; // Twój RuName z konfiguracji platformy sprzedażowej
    const scope = arrScopes.join(' '); // Połącz tablicę zakresów w jeden string oddzielony spacjami

    // Dodaj parametr 'state', aby bezpiecznie zidentyfikować rekord po powrocie. Przekazujemy ID sprzedawcy, ID rekordu poświadczeń, RuName (redirectUrl) oraz adres główny serwisu
    const state = `sellerId=${props.formProps.data.id}&credentialId=${credential.id}&baseMainUrl=${baseMainUrl}&ruName=${ruName}`;
    const askCredentials = ''; //"&prompt=login"; // Dodane, aby wymusić ponowne logowanie. Jeśli chcesz, aby sesja była pamiętana w ciastku, wstaw pusty string zamiast tego.

    // Pełny URL autoryzacji
    const authUrl = `${authMainUrl}/oauth2/authorize?client_id=${clientId}&response_type=code&redirect_uri=${ruName}&scope=${encodeURIComponent(scope)}&state=${encodeURIComponent(state)}${askCredentials}`;
    // Na wszelki wypadek usuń dotychczasowy listener (o ile istnieje)
    window.removeEventListener('message', handleMessageListener);
    // Dodaj listener nasłuchujący wiadomości z innego okna (z \resources\views\oauth\callback.blade.php)
    window.addEventListener('message', handleMessageListener);

    // Otwórz URL autoryzacji w serwisie eBay w nowym oknie
    window.open(authUrl, '_blank', 'width=600,height=700');
}

// -------------------------------------------------------------------------------------------------
// Funkcja do odnowienia refresh tokena Allegro
const renewAllegroToken = async (credential) => {
    const arrScopes = (credential.scopes || '')
        .split(/[\n\s,;]+/)
        .map(s => s.trim())
        .filter(s => s.length > 0);

    const conf = await getRecord('marketplaces', ['base_url_prod', 'base_url_sandbox', 'auth_url_prod', 'auth_url_sandbox'], { 'id': credential.marketplace_id });

    if (!conf) {
        screenMessage({ message: __('No marketplace configuration found'), title: __('Error'), type: 'error', position: 'center', timeout: 10 });
        return;
    }

    const isProduction = (credential.environment === 'production');
    //const baseMainUrl = isProduction ? conf.base_url_prod : conf.base_url_sandbox;
    const authMainUrl = isProduction ? conf.auth_url_prod : conf.auth_url_sandbox;

    // Pobierz parametry potrzebne do zbudowania URL autoryzacji
    const clientId = credential.client_id;
    const ruName = credential.ru_name; // Twój RuName z konfiguracji platformy sprzedażowej
    const scope = arrScopes.join(' '); // Połącz tablicę zakresów w jeden string oddzielony spacjami

    // Dodaj parametr 'state', aby bezpiecznie zidentyfikować rekord po powrocie. Przekazujemy ID sprzedawcy, ID rekordu poświadczeń, RuName (redirectUrl) oraz adres główny serwisu
    const state = `sellerId=${props.formProps.data.id}&credentialId=${credential.id}&authMainUrl=${authMainUrl}&ruName=${ruName}`;
    const askCredentials = "&prompt=confirm"; // Dodane, aby wymusić ponowne logowanie. Jeśli chcesz, aby sesja była pamiętana w ciastku, wstaw pusty string zamiast tego.

    const authUrl = `${authMainUrl}/auth/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${ruName}&scope=${encodeURIComponent(scope)}&state=${encodeURIComponent(state)}${askCredentials}`;

    // Na wszelki wypadek usuń dotychczasowy listener (o ile istnieje)
    window.removeEventListener('message', handleMessageListener);
    // Dodaj listener nasłuchujący wiadomości z innego okna (z \resources\views\oauth\callback.blade.php)
    window.addEventListener('message', handleMessageListener);

    // Otwórz URL autoryzacji w serwisie eBay w nowym oknie
    window.open(authUrl, '_blank', 'width=600,height=700');
}

// -------------------------------------------------------------------------------------------------
</script>

<style lang="scss" scoped></style>
